import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClient2x7qc5z8fmeal as HttpClient } from './HttpClient.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { engines_getInstance1y1q23sy4bogu as engines_getInstance } from './engine/Loader.mjs';
import { Js_instance94aldsayunvq as Js_instance } from './engine/js/Js.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_FACTORY() {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return FACTORY;
}
var FACTORY;
function HttpClient_0(block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_HttpClient_web_kt__pyfqvb();
  return HttpClient(get_FACTORY(), block);
}
function HttpClient$lambda(_this__u8e3s4) {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return Unit_instance;
}
var properties_initialized_HttpClient_web_kt_zbb0cl;
function _init_properties_HttpClient_web_kt__pyfqvb() {
  if (!properties_initialized_HttpClient_web_kt_zbb0cl) {
    properties_initialized_HttpClient_web_kt_zbb0cl = true;
    var tmp0 = engines_getInstance();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!equals(element, Js_instance)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    FACTORY = tmp0_elvis_lhs == null ? Js_instance : tmp0_elvis_lhs;
  }
}
//region block: exports
export {
  HttpClient_0 as HttpClient3584jcajl7sef,
};
//endregion

//# sourceMappingURL=HttpClient.web.mjs.map
